import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

interface HomeHeroSectionProps {
  title?: string;
  subtitle?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  backgroundImage?: string;
}

const HomeHeroSection: React.FC<HomeHeroSectionProps> = ({
  title = "Sinopec Lubricants Available in Canada",
  subtitle = "PES Lube Canada supplies Sinopec oils, greases, and specialty fluids directly to Canadian customers, with local product availability and support for pricing, documentation, and product matching.",
  primaryButtonText = "Explore Products",
  secondaryButtonText = "Request a Quote",
  backgroundImage = '/images/hero/hero1.png'
}) => {
  return (
    <section className="relative min-h-[600px] flex items-center bg-red-600 text-white">
      {/* Background image with gradient overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
          backgroundPosition: 'right center'
        }}
      ></div>
      
      {/* Gradient overlay - from transparent (right) to solid red (left) */}
      <div className="absolute inset-0 bg-gradient-to-r from-red-600 via-red-600 to-transparent"></div>
      
      {/* Slight dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black opacity-10"></div>
      
      {/* Content */}
      <div className="container mx-auto px-4 pt-12 pb-28 md:pt-8 md:pb-32 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">{title}</h1>
          <p className="text-xl md:text-2xl mb-10 text-white text-opacity-90 leading-relaxed max-w-2xl">
            {subtitle}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Link 
              to="/products" 
              className="bg-white text-red-600 hover:bg-gray-100 px-8 py-4 rounded-md font-medium text-lg inline-flex items-center justify-center transition-colors"
            >
              {primaryButtonText}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
            
            <Link 
              to="/contact" 
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 rounded-md font-medium text-lg inline-flex items-center justify-center transition-colors"
            >
              {secondaryButtonText}
            </Link>
          </div>
        </div>
      </div>
      
      {/* Bottom wave shape */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 160" className="w-full h-auto fill-white">
          <path d="M0,128L80,117.3C160,107,320,85,480,90.7C640,96,800,128,960,128C1120,128,1280,96,1360,80L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
        </svg>
      </div>
    </section>
  );
};

export default HomeHeroSection; 
